export const SupportLink = 'https://innowise-group.atlassian.net/servicedesk/customer/portals';
export const BugReportLink = 'https://docs.google.com/forms/d/1xusXk8LIYSFoZ4ppkODXc8GxV_2cIxVvlSof3wjtN4k/edit';
export const HelpLink = 'https://innowise-group.atlassian.net/wiki/spaces/CS/pages/2362146832';
export const LookerStudio = 'https://lookerstudio.google.com/reporting/6b984ca8-2aee-424c-a68a-de4e5bef8213';
